import { render } from "./TerminalInfo.vue?vue&type=template&id=7264460f"
import script from "./TerminalInfo.vue?vue&type=script&lang=js"
export * from "./TerminalInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__